module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/window-curtain/texture.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/window-curtain/texture.png
// module id = 501
// module chunks = 0